import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function usePaymentRemarksList() {

    //User toast
    const toast = useToast()

    const refPaymentRemarkListTable = ref(null)

    const tableColumns = [
        {key: 'name', label:'名稱', sortable: true},
        {key: 'remark', label: '支付備註'},
        {key: 'action', label: '操作'}
    ]

    const perPage = ref(10)
    const totalPaymentRemarks = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(false)

    const dataMeta = computed(() => {
        const localItemsCount = refPaymentRemarkListTable.value ? refPaymentRemarkListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalPaymentRemarks.value,
        }
    })

    const refetchData = () => {
        refPaymentRemarkListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchPaymentRemarks = (ctx, callback) => {
        store.dispatch('setting-paymentremark/fetchPaymentRemarks',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {payment_remarks, total} = response.data
            callback(payment_remarks)
            totalPaymentRemarks.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching payment methods list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchPaymentRemarks,
        tableColumns,
        perPage,
        currentPage,
        totalPaymentRemarks,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refPaymentRemarkListTable,
        ability,
        refetchData
    }

}